import EditPrompt, { EditPromptProps } from './EditPrompt';

export type { EditPromptProps };
export default EditPrompt;
